import { FieldTag } from '../../../field/field/domain/field.interface';
export var InspectionType;
(function (InspectionType) {
    InspectionType["TREE_D"] = "TreeD";
    InspectionType["BASIC"] = "Basic";
    InspectionType["BASIC_RISK_ASSESSMENT"] = "BasicRiskAssessment";
})(InspectionType || (InspectionType = {}));
export const INSPECTION_PHOTO_MAX = 25;
export const INSPECTION_COMMENTS_MAX = 255;
export const TREE_D_REQUIRED_FIELD_TAGS = [FieldTag.SPECIES_COMMON];
export const BASIC_RISK_ASSESSMENT_FIELD_TAGS = [
    FieldTag.RISK_ASSESSED_TREE_PART,
    FieldTag.RISK_LIKELIHOOD_OF_FAILURE,
    FieldTag.RISK_LIKELIHOOD_OF_IMPACTING_TARGET,
    FieldTag.RISK_LIKELIHOOD,
    FieldTag.RISK_CONSEQUENCE_OF_FAILURE,
    FieldTag.RISK_RATING,
    FieldTag.RISK_TARGET,
];
export const INSPECTION_FIELD_SCHEMA = {
    [InspectionType.TREE_D]: [
        FieldTag.SPECIES_COMMON,
        FieldTag.SPECIES_LATIN,
        FieldTag.CROWN_PERCENT_DIEBACK,
        FieldTag.CROWN_CONDITION,
        FieldTag.LAND_USE,
        FieldTag.CLEARANCE_PRUNE_NEEDED,
        FieldTag.GROWING_SPACE,
        FieldTag.REMOTE_ASSESSED_CLEARANCE_ISSUES,
        FieldTag.CROWN_DIEBACK_RANGE,
        FieldTag.NOTES,
    ],
    [InspectionType.BASIC]: [
        FieldTag.STATUS,
        FieldTag.DBH,
        FieldTag.TREE_HEIGHT,
        FieldTag.CONDITION,
        FieldTag.OBSERVATIONS,
        FieldTag.OBSERVATIONS_ABIOTIC,
        FieldTag.OBSERVATIONS_BIOTIC,
        FieldTag.OBSERVATIONS_CHARACTERISTICS,
        FieldTag.OBSERVATION_COMMENTS,
        FieldTag.MULTI_STEM_DBH,
        FieldTag.MULTI_STEM_TRIGGER,
    ],
    [InspectionType.BASIC_RISK_ASSESSMENT]: BASIC_RISK_ASSESSMENT_FIELD_TAGS,
};
//# sourceMappingURL=inspection.interface.js.map